import { Component, Input, ElementRef, HostListener, OnDestroy, ChangeDetectorRef } from '@angular/core';

export type ActionIcon = 'plus' | 'file' | 'file-pdf' | 'eye' | 'card' | 'bank';

export interface ActionItem {
    label: string;
    icon?: ActionIcon;
    action: () => void;
    visible?: boolean;
}

@Component({
    selector: 'app-actions-dropdown',
    templateUrl: './actions-dropdown.component.html',
    styleUrls: ['./actions-dropdown.component.scss']
})
export class ActionsDropdownComponent implements OnDestroy {

    /**
     * Instancia con el menú abierto actualmente (compartida entre todas las instancias).
     * El trigger hace stopPropagation, por lo que el listener de document:click de las
     * demás instancias no llega a ejecutarse; con esta referencia, al abrir un menú se
     * cierra explícitamente el que estuviera abierto.
     */
    private static openInstance: ActionsDropdownComponent | null = null;

    @Input() label: string = 'Acciones';
    @Input() items: ActionItem[] = [];

    _open: boolean = false;

    constructor(private elementRef: ElementRef, private cdr: ChangeDetectorRef) {}

    toggle(): void {
        if (this._open) {
            this.close();
        } else {
            this.open();
        }
    }

    select(item: ActionItem): void {
        this.close();
        item.action();
    }

    ngOnDestroy(): void {
        if (ActionsDropdownComponent.openInstance === this) {
            ActionsDropdownComponent.openInstance = null;
        }
    }

    private open(): void {
        const previous = ActionsDropdownComponent.openInstance;
        if (previous && previous !== this) {
            previous.close();
        }
        this._open = true;
        ActionsDropdownComponent.openInstance = this;
    }

    private close(): void {
        this._open = false;
        if (ActionsDropdownComponent.openInstance === this) {
            ActionsDropdownComponent.openInstance = null;
        }
        // Por si la instancia cerrada cuelga de un padre OnPush.
        this.cdr.markForCheck();
    }

    get visibleItems(): ActionItem[] {
        return this.items.filter(item => item.visible !== false);
    }

    trackByLabel(_index: number, item: ActionItem): string {
        return item.label;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        if (this._open && !this.elementRef.nativeElement.contains(event.target as Node)) {
            this.close();
        }
    }
}
